import React from 'react';
import { ActionHeader } from './makeNct';

type WhiteLayoutProps = {
    children?: JSX.Element;
    header?: string;
    subClasses?: string;
    subHeader?: string;
    containerClass?: string;
};
export default function WhiteLayout({
    children,
    header = '',
    subClasses = '',
    subHeader = '',
    containerClass = '',
}: WhiteLayoutProps) {
    return (
        <div className={`curved-bg ${subClasses}`}>
            <ActionHeader header={header} subHeader={subHeader} />
            <div className={`curved-bg-content ${containerClass}`}>{children}</div>
        </div>
    );
}
